import { render, staticRenderFns } from "./QuizResults.vue?vue&type=template&id=0b9d40a3&scoped=true&"
import script from "./QuizResults.vue?vue&type=script&lang=js&"
export * from "./QuizResults.vue?vue&type=script&lang=js&"
import style0 from "./QuizResults.vue?vue&type=style&index=0&id=0b9d40a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d40a3",
  null
  
)

export default component.exports